// extracted by mini-css-extract-plugin
module.exports = {"contact":"Contact_contact__fuqV-","form":"Contact_form__3tBtT"};